import { render } from "./WithOffset.vue?vue&type=template&id=085dc08c"
import script from "./WithOffset.vue?vue&type=script&lang=js"
export * from "./WithOffset.vue?vue&type=script&lang=js"
script.render = render

export default script